export const ticketingPathBaseUrl = process.env.REACT_APP_TICKETING_PATH;
export const masterBaseUrl = process.env.REACT_APP_MASTER_PATH;
export const authBaseUrl = process.env.REACT_APP_AUTH_URL;
export const reportsBaseUrl = process.env.REACT_APP_REPORTS_BASE_URL;
export const integrationBaseUrl = process.env.REACT_APP_INTEGRATION_URL;
export const activityBaseUrl = process.env.REACT_APP_ACTIVITY_URL;
export const teamBaseUrl = process.env.REACT_APP_TEAM_URL;
export const socialBaseUrl = process.env.REACT_APP_SOCIAL_URL;
export const gratificationBaseUrl = process.env.REACT_APP_GRATIFICATION_URL;
export const moderationBaseUrl = process.env.REACT_APP_MODERATION_URL;
export const userBaseUrl = process.env.REACT_APP_USER_BASEURL;
export const userLoginAppUrl = process.env.REACT_APP_USER_LOGIN_URL;
export const userDashboardBaseUrl = process.env.REACT_APP_USER_DASHBOARD_URL;
export const userOrderDetailsUrl = process.env.REACT_APP_USER_ORDER_DETAILS_URL;
export const myParticipationsDetailsUrl = process.env.REACT_APP_MY_PARTICIPATIONS_DETAILS_URL;
export const userChangePasswordUrl = process.env.REACT_APP_USER_CHANGE_PASSWORD_URL;
export const isGoogleAnalyticsEnabled = process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS;
export const orderManagementUrl=process.env.REACT_APP_ORDER_MANAGEMENT;
export const authMethod = process.env.REACT_APP_AUTHMETHOD;
export const timeDifference = process.env.REACT_APP_TIMEDIFFER;
export const projectEnv = process.env.REACT_APP_PROJECT_ENV;
export const userApiBaseUrl = process.env.REACT_APP_USER_API_BASE_URL;
export const userAddressesUrl = process.env.REACT_APP_USER_ADDRESSES_URL;
export const userTicketingAppUrl = process.env.REACT_APP_USER_TICKETING_URL;